import { render, staticRenderFns } from "./183.vue?vue&type=template&id=8fd978fc&scoped=true&"
var script = {}
import style0 from "./183.vue?vue&type=style&index=0&id=8fd978fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd978fc",
  null
  
)

export default component.exports